import { useEffect, useMemo, useRef, useState } from "react";
import { DRAWERS, drawerZMap, newlyOpened, raiseDrawer } from "../lib/drawerStack.js";

/**
 * z-index per side drawer, most-recently-opened on top (see lib/drawerStack.js), except that the
 * Signal Library is on top of every rail panel while it is open, even one opened after it.
 *
 * @param {{log: boolean, chat: boolean, tsd: boolean, contract: boolean}} open
 * @returns {Record<"log"|"chat"|"tsd"|"contract", number>}
 */
export function useDrawerStack({ log, chat, tsd, contract }) {
  const [order, setOrder] = useState(DRAWERS);
  // The open-state last seen, so only a false → true transition raises a drawer. Seeded
  // with the first render's state: a drawer that starts open (the chat console) keeps its
  // default place instead of being raised on mount.
  const prevRef = useRef({ log, chat, tsd, contract });
  useEffect(() => {
    const next = { log, chat, tsd, contract };
    const opened = newlyOpened(prevRef.current, next);
    prevRef.current = next;
    if (opened.length) setOrder((o) => opened.reduce(raiseDrawer, o));
  }, [log, chat, tsd, contract]);
  // Raised at render only: the stored order is untouched, so closing the Signal Library hands
  // the top back to whichever panel was opened most recently.
  return useMemo(() => drawerZMap(tsd ? raiseDrawer(order, "tsd") : order), [order, tsd]);
}
